/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const createAccommodation = /* GraphQL */ `
  mutation CreateAccommodation(
    $input: CreateAccommodationInput!
    $condition: ModelAccommodationConditionInput
  ) {
    createAccommodation(input: $input, condition: $condition) {
      id
      owner
      postId
      tripId
      title
      details
      accommodationType
      otherAccommodationType
      hotelName
      address
      link
      cost
      costDistributionType
      checkInDate
      checkOutDate
      participants {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAccommodation = /* GraphQL */ `
  mutation UpdateAccommodation(
    $input: UpdateAccommodationInput!
    $condition: ModelAccommodationConditionInput
  ) {
    updateAccommodation(input: $input, condition: $condition) {
      id
      owner
      postId
      tripId
      title
      details
      accommodationType
      otherAccommodationType
      hotelName
      address
      link
      cost
      costDistributionType
      checkInDate
      checkOutDate
      participants {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAccommodation = /* GraphQL */ `
  mutation DeleteAccommodation(
    $input: DeleteAccommodationInput!
    $condition: ModelAccommodationConditionInput
  ) {
    deleteAccommodation(input: $input, condition: $condition) {
      id
      owner
      postId
      tripId
      title
      details
      accommodationType
      otherAccommodationType
      hotelName
      address
      link
      cost
      costDistributionType
      checkInDate
      checkOutDate
      participants {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAccommodationParticipant = /* GraphQL */ `
  mutation CreateAccommodationParticipant(
    $input: CreateAccommodationParticipantInput!
    $condition: ModelAccommodationParticipantConditionInput
  ) {
    createAccommodationParticipant(input: $input, condition: $condition) {
      id
      userId
      accommodationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAccommodationParticipant = /* GraphQL */ `
  mutation UpdateAccommodationParticipant(
    $input: UpdateAccommodationParticipantInput!
    $condition: ModelAccommodationParticipantConditionInput
  ) {
    updateAccommodationParticipant(input: $input, condition: $condition) {
      id
      userId
      accommodationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAccommodationParticipant = /* GraphQL */ `
  mutation DeleteAccommodationParticipant(
    $input: DeleteAccommodationParticipantInput!
    $condition: ModelAccommodationParticipantConditionInput
  ) {
    deleteAccommodationParticipant(input: $input, condition: $condition) {
      id
      userId
      accommodationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createActivity = /* GraphQL */ `
  mutation CreateActivity(
    $input: CreateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    createActivity(input: $input, condition: $condition) {
      id
      owner
      postId
      tripId
      title
      details
      activeDate
      potentialDates
      address
      duration
      cost
      link
      costDistributionType
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      participants {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateActivity = /* GraphQL */ `
  mutation UpdateActivity(
    $input: UpdateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    updateActivity(input: $input, condition: $condition) {
      id
      owner
      postId
      tripId
      title
      details
      activeDate
      potentialDates
      address
      duration
      cost
      link
      costDistributionType
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      participants {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteActivity = /* GraphQL */ `
  mutation DeleteActivity(
    $input: DeleteActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    deleteActivity(input: $input, condition: $condition) {
      id
      owner
      postId
      tripId
      title
      details
      activeDate
      potentialDates
      address
      duration
      cost
      link
      costDistributionType
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      participants {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createActivityParticipant = /* GraphQL */ `
  mutation CreateActivityParticipant(
    $input: CreateActivityParticipantInput!
    $condition: ModelActivityParticipantConditionInput
  ) {
    createActivityParticipant(input: $input, condition: $condition) {
      id
      userId
      activityId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateActivityParticipant = /* GraphQL */ `
  mutation UpdateActivityParticipant(
    $input: UpdateActivityParticipantInput!
    $condition: ModelActivityParticipantConditionInput
  ) {
    updateActivityParticipant(input: $input, condition: $condition) {
      id
      userId
      activityId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteActivityParticipant = /* GraphQL */ `
  mutation DeleteActivityParticipant(
    $input: DeleteActivityParticipantInput!
    $condition: ModelActivityParticipantConditionInput
  ) {
    deleteActivityParticipant(input: $input, condition: $condition) {
      id
      userId
      activityId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createBetaKey = /* GraphQL */ `
  mutation CreateBetaKey(
    $input: CreateBetaKeyInput!
    $condition: ModelBetaKeyConditionInput
  ) {
    createBetaKey(input: $input, condition: $condition) {
      id
      owner
      userId
      email
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateBetaKey = /* GraphQL */ `
  mutation UpdateBetaKey(
    $input: UpdateBetaKeyInput!
    $condition: ModelBetaKeyConditionInput
  ) {
    updateBetaKey(input: $input, condition: $condition) {
      id
      owner
      userId
      email
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteBetaKey = /* GraphQL */ `
  mutation DeleteBetaKey(
    $input: DeleteBetaKeyInput!
    $condition: ModelBetaKeyConditionInput
  ) {
    deleteBetaKey(input: $input, condition: $condition) {
      id
      owner
      userId
      email
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      postId
      postIdCommentType
      owner
      repliedToCommentId
      comment
      isReplyComment
      repliedToComment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      replyComments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          owner
          commentId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      postId
      postIdCommentType
      owner
      repliedToCommentId
      comment
      isReplyComment
      repliedToComment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      replyComments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          owner
          commentId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      postId
      postIdCommentType
      owner
      repliedToCommentId
      comment
      isReplyComment
      repliedToComment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      replyComments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          owner
          commentId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFeedback = /* GraphQL */ `
  mutation UpdateFeedback(
    $input: UpdateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    updateFeedback(input: $input, condition: $condition) {
      id
      email
      isUser
      title
      details
      category
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFeedback = /* GraphQL */ `
  mutation DeleteFeedback(
    $input: DeleteFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    deleteFeedback(input: $input, condition: $condition) {
      id
      email
      isUser
      title
      details
      category
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFlight = /* GraphQL */ `
  mutation CreateFlight(
    $input: CreateFlightInput!
    $condition: ModelFlightConditionInput
  ) {
    createFlight(input: $input, condition: $condition) {
      id
      postId
      tripId
      owner
      title
      details
      cost
      participants {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          flightId
          tripId
          owner
          departTime
          arrivalTime
          airline
          flightNumber
          departureAirport
          arrivalAirport
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFlight = /* GraphQL */ `
  mutation UpdateFlight(
    $input: UpdateFlightInput!
    $condition: ModelFlightConditionInput
  ) {
    updateFlight(input: $input, condition: $condition) {
      id
      postId
      tripId
      owner
      title
      details
      cost
      participants {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          flightId
          tripId
          owner
          departTime
          arrivalTime
          airline
          flightNumber
          departureAirport
          arrivalAirport
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFlight = /* GraphQL */ `
  mutation DeleteFlight(
    $input: DeleteFlightInput!
    $condition: ModelFlightConditionInput
  ) {
    deleteFlight(input: $input, condition: $condition) {
      id
      postId
      tripId
      owner
      title
      details
      cost
      participants {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          flightId
          tripId
          owner
          departTime
          arrivalTime
          airline
          flightNumber
          departureAirport
          arrivalAirport
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFlightInformation = /* GraphQL */ `
  mutation CreateFlightInformation(
    $input: CreateFlightInformationInput!
    $condition: ModelFlightInformationConditionInput
  ) {
    createFlightInformation(input: $input, condition: $condition) {
      id
      flightId
      tripId
      owner
      departTime
      arrivalTime
      airline
      flightNumber
      departureAirport
      arrivalAirport
      flightPost {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFlightInformation = /* GraphQL */ `
  mutation UpdateFlightInformation(
    $input: UpdateFlightInformationInput!
    $condition: ModelFlightInformationConditionInput
  ) {
    updateFlightInformation(input: $input, condition: $condition) {
      id
      flightId
      tripId
      owner
      departTime
      arrivalTime
      airline
      flightNumber
      departureAirport
      arrivalAirport
      flightPost {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFlightInformation = /* GraphQL */ `
  mutation DeleteFlightInformation(
    $input: DeleteFlightInformationInput!
    $condition: ModelFlightInformationConditionInput
  ) {
    deleteFlightInformation(input: $input, condition: $condition) {
      id
      flightId
      tripId
      owner
      departTime
      arrivalTime
      airline
      flightNumber
      departureAirport
      arrivalAirport
      flightPost {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFlightParticipant = /* GraphQL */ `
  mutation CreateFlightParticipant(
    $input: CreateFlightParticipantInput!
    $condition: ModelFlightParticipantConditionInput
  ) {
    createFlightParticipant(input: $input, condition: $condition) {
      id
      userId
      flightId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFlightParticipant = /* GraphQL */ `
  mutation UpdateFlightParticipant(
    $input: UpdateFlightParticipantInput!
    $condition: ModelFlightParticipantConditionInput
  ) {
    updateFlightParticipant(input: $input, condition: $condition) {
      id
      userId
      flightId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFlightParticipant = /* GraphQL */ `
  mutation DeleteFlightParticipant(
    $input: DeleteFlightParticipantInput!
    $condition: ModelFlightParticipantConditionInput
  ) {
    deleteFlightParticipant(input: $input, condition: $condition) {
      id
      userId
      flightId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFriendshipRequest = /* GraphQL */ `
  mutation CreateFriendshipRequest(
    $input: CreateFriendshipRequestInput!
    $condition: ModelFriendshipRequestConditionInput
  ) {
    createFriendshipRequest(input: $input, condition: $condition) {
      id
      requestType
      friendshipId
      senderId
      recipientId
      createdAt
      updatedAt
    }
  }
`;
export const updateFriendshipRequest = /* GraphQL */ `
  mutation UpdateFriendshipRequest(
    $input: UpdateFriendshipRequestInput!
    $condition: ModelFriendshipRequestConditionInput
  ) {
    updateFriendshipRequest(input: $input, condition: $condition) {
      id
      requestType
      friendshipId
      senderId
      recipientId
      createdAt
      updatedAt
    }
  }
`;
export const deleteFriendshipRequest = /* GraphQL */ `
  mutation DeleteFriendshipRequest(
    $input: DeleteFriendshipRequestInput!
    $condition: ModelFriendshipRequestConditionInput
  ) {
    deleteFriendshipRequest(input: $input, condition: $condition) {
      id
      requestType
      friendshipId
      senderId
      recipientId
      createdAt
      updatedAt
    }
  }
`;
export const createPostLike = /* GraphQL */ `
  mutation CreatePostLike(
    $input: CreatePostLikeInput!
    $condition: ModelPostLikeConditionInput
  ) {
    createPostLike(input: $input, condition: $condition) {
      id
      postId
      owner
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updatePostLike = /* GraphQL */ `
  mutation UpdatePostLike(
    $input: UpdatePostLikeInput!
    $condition: ModelPostLikeConditionInput
  ) {
    updatePostLike(input: $input, condition: $condition) {
      id
      postId
      owner
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deletePostLike = /* GraphQL */ `
  mutation DeletePostLike(
    $input: DeletePostLikeInput!
    $condition: ModelPostLikeConditionInput
  ) {
    deletePostLike(input: $input, condition: $condition) {
      id
      postId
      owner
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCommentLike = /* GraphQL */ `
  mutation CreateCommentLike(
    $input: CreateCommentLikeInput!
    $condition: ModelCommentLikeConditionInput
  ) {
    createCommentLike(input: $input, condition: $condition) {
      id
      owner
      commentId
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCommentLike = /* GraphQL */ `
  mutation UpdateCommentLike(
    $input: UpdateCommentLikeInput!
    $condition: ModelCommentLikeConditionInput
  ) {
    updateCommentLike(input: $input, condition: $condition) {
      id
      owner
      commentId
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCommentLike = /* GraphQL */ `
  mutation DeleteCommentLike(
    $input: DeleteCommentLikeInput!
    $condition: ModelCommentLikeConditionInput
  ) {
    deleteCommentLike(input: $input, condition: $condition) {
      id
      owner
      commentId
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createNotificationSetting = /* GraphQL */ `
  mutation CreateNotificationSetting(
    $input: CreateNotificationSettingInput!
    $condition: ModelNotificationSettingConditionInput
  ) {
    createNotificationSetting(input: $input, condition: $condition) {
      id
      notificationSettingType
      notificationType
      createdAt
      updatedAt
    }
  }
`;
export const updateNotificationSetting = /* GraphQL */ `
  mutation UpdateNotificationSetting(
    $input: UpdateNotificationSettingInput!
    $condition: ModelNotificationSettingConditionInput
  ) {
    updateNotificationSetting(input: $input, condition: $condition) {
      id
      notificationSettingType
      notificationType
      createdAt
      updatedAt
    }
  }
`;
export const deleteNotificationSetting = /* GraphQL */ `
  mutation DeleteNotificationSetting(
    $input: DeleteNotificationSettingInput!
    $condition: ModelNotificationSettingConditionInput
  ) {
    deleteNotificationSetting(input: $input, condition: $condition) {
      id
      notificationSettingType
      notificationType
      createdAt
      updatedAt
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      owner
      notificationType
      notificationStatus
      ownerStatusKey
      tripInvitationId
      friendshipId
      userId
      tripId
      commentId
      postId
      tripInvitation {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      friendship {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      owner
      notificationType
      notificationStatus
      ownerStatusKey
      tripInvitationId
      friendshipId
      userId
      tripId
      commentId
      postId
      tripInvitation {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      friendship {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      owner
      notificationType
      notificationStatus
      ownerStatusKey
      tripInvitationId
      friendshipId
      userId
      tripId
      commentId
      postId
      tripInvitation {
        id
        owners
        senderId
        recipientId
        tripId
        permissionType
        status
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        sender {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        recipient {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      comment {
        id
        postId
        postIdCommentType
        owner
        repliedToCommentId
        comment
        isReplyComment
        repliedToComment {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        replyComments {
          nextToken
        }
        likes {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      friendship {
        id
        primaryUserId
        primaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        secondaryUserId
        secondaryUser {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        friendshipStatus
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createPost = /* GraphQL */ `
  mutation CreatePost(
    $input: CreatePostInput!
    $condition: ModelPostConditionInput
  ) {
    createPost(input: $input, condition: $condition) {
      id
      owner
      activityId
      accommodationId
      transportationId
      flightId
      tripId
      postType
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          postId
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updatePost = /* GraphQL */ `
  mutation UpdatePost(
    $input: UpdatePostInput!
    $condition: ModelPostConditionInput
  ) {
    updatePost(input: $input, condition: $condition) {
      id
      owner
      activityId
      accommodationId
      transportationId
      flightId
      tripId
      postType
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          postId
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deletePost = /* GraphQL */ `
  mutation DeletePost(
    $input: DeletePostInput!
    $condition: ModelPostConditionInput
  ) {
    deletePost(input: $input, condition: $condition) {
      id
      owner
      activityId
      accommodationId
      transportationId
      flightId
      tripId
      postType
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        items {
          id
          postId
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      activity {
        id
        owner
        postId
        tripId
        title
        details
        activeDate
        potentialDates
        address
        duration
        cost
        link
        costDistributionType
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        participants {
          nextToken
        }
        createdAt
        updatedAt
      }
      accommodation {
        id
        owner
        postId
        tripId
        title
        details
        accommodationType
        otherAccommodationType
        hotelName
        address
        link
        cost
        costDistributionType
        checkInDate
        checkOutDate
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      flight {
        id
        postId
        tripId
        owner
        title
        details
        cost
        participants {
          nextToken
        }
        flights {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createResource = /* GraphQL */ `
  mutation CreateResource(
    $input: CreateResourceInput!
    $condition: ModelResourceConditionInput
  ) {
    createResource(input: $input, condition: $condition) {
      id
      owner
      resourceName
      description
      resourcePath
      createdAt
      updatedAt
    }
  }
`;
export const updateResource = /* GraphQL */ `
  mutation UpdateResource(
    $input: UpdateResourceInput!
    $condition: ModelResourceConditionInput
  ) {
    updateResource(input: $input, condition: $condition) {
      id
      owner
      resourceName
      description
      resourcePath
      createdAt
      updatedAt
    }
  }
`;
export const deleteResource = /* GraphQL */ `
  mutation DeleteResource(
    $input: DeleteResourceInput!
    $condition: ModelResourceConditionInput
  ) {
    deleteResource(input: $input, condition: $condition) {
      id
      owner
      resourceName
      description
      resourcePath
      createdAt
      updatedAt
    }
  }
`;
export const createTransportation = /* GraphQL */ `
  mutation CreateTransportation(
    $input: CreateTransportationInput!
    $condition: ModelTransportationConditionInput
  ) {
    createTransportation(input: $input, condition: $condition) {
      id
      owner
      tripId
      postId
      title
      transportationType
      details
      company
      pickUpDate
      dropOffDate
      vehicleType
      vehicleMake
      vehicleModel
      vehicleYear
      numberOfSeats
      pickUpLocation
      destination
      link
      cost
      typeOfPublicTransportation
      typeOfTransportation
      costDistributionType
      participants {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTransportation = /* GraphQL */ `
  mutation UpdateTransportation(
    $input: UpdateTransportationInput!
    $condition: ModelTransportationConditionInput
  ) {
    updateTransportation(input: $input, condition: $condition) {
      id
      owner
      tripId
      postId
      title
      transportationType
      details
      company
      pickUpDate
      dropOffDate
      vehicleType
      vehicleMake
      vehicleModel
      vehicleYear
      numberOfSeats
      pickUpLocation
      destination
      link
      cost
      typeOfPublicTransportation
      typeOfTransportation
      costDistributionType
      participants {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTransportation = /* GraphQL */ `
  mutation DeleteTransportation(
    $input: DeleteTransportationInput!
    $condition: ModelTransportationConditionInput
  ) {
    deleteTransportation(input: $input, condition: $condition) {
      id
      owner
      tripId
      postId
      title
      transportationType
      details
      company
      pickUpDate
      dropOffDate
      vehicleType
      vehicleMake
      vehicleModel
      vehicleYear
      numberOfSeats
      pickUpLocation
      destination
      link
      cost
      typeOfPublicTransportation
      typeOfTransportation
      costDistributionType
      participants {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      post {
        id
        owner
        activityId
        accommodationId
        transportationId
        flightId
        tripId
        postType
        comments {
          nextToken
        }
        likes {
          nextToken
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        activity {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        accommodation {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        transportation {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        flight {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTransportationParticipant = /* GraphQL */ `
  mutation CreateTransportationParticipant(
    $input: CreateTransportationParticipantInput!
    $condition: ModelTransportationParticipantConditionInput
  ) {
    createTransportationParticipant(input: $input, condition: $condition) {
      id
      userId
      transportationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTransportationParticipant = /* GraphQL */ `
  mutation UpdateTransportationParticipant(
    $input: UpdateTransportationParticipantInput!
    $condition: ModelTransportationParticipantConditionInput
  ) {
    updateTransportationParticipant(input: $input, condition: $condition) {
      id
      userId
      transportationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTransportationParticipant = /* GraphQL */ `
  mutation DeleteTransportationParticipant(
    $input: DeleteTransportationParticipantInput!
    $condition: ModelTransportationParticipantConditionInput
  ) {
    deleteTransportationParticipant(input: $input, condition: $condition) {
      id
      userId
      transportationId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      transportation {
        id
        owner
        tripId
        postId
        title
        transportationType
        details
        company
        pickUpDate
        dropOffDate
        vehicleType
        vehicleMake
        vehicleModel
        vehicleYear
        numberOfSeats
        pickUpLocation
        destination
        link
        cost
        typeOfPublicTransportation
        typeOfTransportation
        costDistributionType
        participants {
          nextToken
        }
        post {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        trip {
          id
          tripName
          destination
          startDate
          endDate
          owner
          createdAt
          updatedAt
        }
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTrip = /* GraphQL */ `
  mutation CreateTrip(
    $input: CreateTripInput!
    $condition: ModelTripConditionInput
  ) {
    createTrip(input: $input, condition: $condition) {
      id
      tripName
      destination
      startDate
      endDate
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      members {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      activities {
        items {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodations {
        items {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        nextToken
      }
      transportations {
        items {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        nextToken
      }
      posts {
        items {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTrip = /* GraphQL */ `
  mutation UpdateTrip(
    $input: UpdateTripInput!
    $condition: ModelTripConditionInput
  ) {
    updateTrip(input: $input, condition: $condition) {
      id
      tripName
      destination
      startDate
      endDate
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      members {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      activities {
        items {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodations {
        items {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        nextToken
      }
      transportations {
        items {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        nextToken
      }
      posts {
        items {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTrip = /* GraphQL */ `
  mutation DeleteTrip(
    $input: DeleteTripInput!
    $condition: ModelTripConditionInput
  ) {
    deleteTrip(input: $input, condition: $condition) {
      id
      tripName
      destination
      startDate
      endDate
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      members {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      activities {
        items {
          id
          owner
          postId
          tripId
          title
          details
          activeDate
          potentialDates
          address
          duration
          cost
          link
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodations {
        items {
          id
          owner
          postId
          tripId
          title
          details
          accommodationType
          otherAccommodationType
          hotelName
          address
          link
          cost
          costDistributionType
          checkInDate
          checkOutDate
          createdAt
          updatedAt
        }
        nextToken
      }
      transportations {
        items {
          id
          owner
          tripId
          postId
          title
          transportationType
          details
          company
          pickUpDate
          dropOffDate
          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          numberOfSeats
          pickUpLocation
          destination
          link
          cost
          typeOfPublicTransportation
          typeOfTransportation
          costDistributionType
          createdAt
          updatedAt
        }
        nextToken
      }
      flights {
        items {
          id
          postId
          tripId
          owner
          title
          details
          cost
          createdAt
          updatedAt
        }
        nextToken
      }
      posts {
        items {
          id
          owner
          activityId
          accommodationId
          transportationId
          flightId
          tripId
          postType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTripMember = /* GraphQL */ `
  mutation CreateTripMember(
    $input: CreateTripMemberInput!
    $condition: ModelTripMemberConditionInput
  ) {
    createTripMember(input: $input, condition: $condition) {
      id
      userId
      tripId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      permissionType
      createdAt
      updatedAt
    }
  }
`;
export const updateTripMember = /* GraphQL */ `
  mutation UpdateTripMember(
    $input: UpdateTripMemberInput!
    $condition: ModelTripMemberConditionInput
  ) {
    updateTripMember(input: $input, condition: $condition) {
      id
      userId
      tripId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      permissionType
      createdAt
      updatedAt
    }
  }
`;
export const deleteTripMember = /* GraphQL */ `
  mutation DeleteTripMember(
    $input: DeleteTripMemberInput!
    $condition: ModelTripMemberConditionInput
  ) {
    deleteTripMember(input: $input, condition: $condition) {
      id
      userId
      tripId
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      permissionType
      createdAt
      updatedAt
    }
  }
`;
export const createTripInvitation = /* GraphQL */ `
  mutation CreateTripInvitation(
    $input: CreateTripInvitationInput!
    $condition: ModelTripInvitationConditionInput
  ) {
    createTripInvitation(input: $input, condition: $condition) {
      id
      owners
      senderId
      recipientId
      tripId
      permissionType
      status
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      recipient {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTripInvitation = /* GraphQL */ `
  mutation UpdateTripInvitation(
    $input: UpdateTripInvitationInput!
    $condition: ModelTripInvitationConditionInput
  ) {
    updateTripInvitation(input: $input, condition: $condition) {
      id
      owners
      senderId
      recipientId
      tripId
      permissionType
      status
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      recipient {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTripInvitation = /* GraphQL */ `
  mutation DeleteTripInvitation(
    $input: DeleteTripInvitationInput!
    $condition: ModelTripInvitationConditionInput
  ) {
    deleteTripInvitation(input: $input, condition: $condition) {
      id
      owners
      senderId
      recipientId
      tripId
      permissionType
      status
      trip {
        id
        tripName
        destination
        startDate
        endDate
        owner
        user {
          id
          username
          name
          profilePicture
          createdAt
          updatedAt
        }
        members {
          nextToken
        }
        activities {
          nextToken
        }
        accommodations {
          nextToken
        }
        transportations {
          nextToken
        }
        flights {
          nextToken
        }
        posts {
          nextToken
        }
        createdAt
        updatedAt
      }
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      recipient {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTripMemberUpdateRequest = /* GraphQL */ `
  mutation CreateTripMemberUpdateRequest(
    $input: CreateTripMemberUpdateRequestInput!
    $condition: ModelTripMemberUpdateRequestConditionInput
  ) {
    createTripMemberUpdateRequest(input: $input, condition: $condition) {
      id
      owner
      tripMemberId
      permissionType
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTripMemberUpdateRequest = /* GraphQL */ `
  mutation UpdateTripMemberUpdateRequest(
    $input: UpdateTripMemberUpdateRequestInput!
    $condition: ModelTripMemberUpdateRequestConditionInput
  ) {
    updateTripMemberUpdateRequest(input: $input, condition: $condition) {
      id
      owner
      tripMemberId
      permissionType
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTripMemberUpdateRequest = /* GraphQL */ `
  mutation DeleteTripMemberUpdateRequest(
    $input: DeleteTripMemberUpdateRequestInput!
    $condition: ModelTripMemberUpdateRequestConditionInput
  ) {
    deleteTripMemberUpdateRequest(input: $input, condition: $condition) {
      id
      owner
      tripMemberId
      permissionType
      sender {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      username
      name
      trips {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      activityParticipant {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodationParticipant {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      flightParticipant {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      transportationParticipant {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      profilePicture
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      username
      name
      trips {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      activityParticipant {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodationParticipant {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      flightParticipant {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      transportationParticipant {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      profilePicture
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      username
      name
      trips {
        items {
          id
          userId
          tripId
          permissionType
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          postId
          postIdCommentType
          owner
          repliedToCommentId
          comment
          isReplyComment
          createdAt
          updatedAt
        }
        nextToken
      }
      activityParticipant {
        items {
          id
          userId
          activityId
          createdAt
          updatedAt
        }
        nextToken
      }
      accommodationParticipant {
        items {
          id
          userId
          accommodationId
          createdAt
          updatedAt
        }
        nextToken
      }
      flightParticipant {
        items {
          id
          userId
          flightId
          createdAt
          updatedAt
        }
        nextToken
      }
      transportationParticipant {
        items {
          id
          userId
          transportationId
          createdAt
          updatedAt
        }
        nextToken
      }
      profilePicture
      createdAt
      updatedAt
    }
  }
`;
export const createUserPii = /* GraphQL */ `
  mutation CreateUserPii(
    $input: CreateUserPIIInput!
    $condition: ModelUserPIIConditionInput
  ) {
    createUserPII(input: $input, condition: $condition) {
      id
      email
      phoneNumber
      birthDate
      createdAt
      updatedAt
    }
  }
`;
export const updateUserPii = /* GraphQL */ `
  mutation UpdateUserPii(
    $input: UpdateUserPIIInput!
    $condition: ModelUserPIIConditionInput
  ) {
    updateUserPII(input: $input, condition: $condition) {
      id
      email
      phoneNumber
      birthDate
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserPii = /* GraphQL */ `
  mutation DeleteUserPii(
    $input: DeleteUserPIIInput!
    $condition: ModelUserPIIConditionInput
  ) {
    deleteUserPII(input: $input, condition: $condition) {
      id
      email
      phoneNumber
      birthDate
      createdAt
      updatedAt
    }
  }
`;
export const updateWaitListEmail = /* GraphQL */ `
  mutation UpdateWaitListEmail(
    $input: UpdateWaitListEmailInput!
    $condition: ModelWaitListEmailConditionInput
  ) {
    updateWaitListEmail(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
    }
  }
`;
export const createFeedback = /* GraphQL */ `
  mutation CreateFeedback(
    $input: CreateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    createFeedback(input: $input, condition: $condition) {
      id
      email
      isUser
      title
      details
      category
      owner
      user {
        id
        username
        name
        trips {
          nextToken
        }
        comments {
          nextToken
        }
        activityParticipant {
          nextToken
        }
        accommodationParticipant {
          nextToken
        }
        flightParticipant {
          nextToken
        }
        transportationParticipant {
          nextToken
        }
        profilePicture
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createWaitListEmail = /* GraphQL */ `
  mutation CreateWaitListEmail(
    $input: CreateWaitListEmailInput!
    $condition: ModelWaitListEmailConditionInput
  ) {
    createWaitListEmail(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
    }
  }
`;
export const deleteWaitListEmail = /* GraphQL */ `
  mutation DeleteWaitListEmail(
    $input: DeleteWaitListEmailInput!
    $condition: ModelWaitListEmailConditionInput
  ) {
    deleteWaitListEmail(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
    }
  }
`;
